export function getBankIdGuiState(
  bankIdStatus,
  bankIdHintCode,
  isIntializing,
  browserType,
  tryingToOpenApp,
  bankIdQrUrl,
  qrCodeButtonClicked,
  startQrCodeOnDesktop,
  eportStatusSuccess,
) {
  const showQrCode =
    ((browserType === "desktop" && startQrCodeOnDesktop) || qrCodeButtonClicked) &&
    bankIdQrUrl &&
    !tryingToOpenApp &&
    bankIdStatus === "pending" &&
    bankIdHintCode === "outstandingTransaction";

  const showLoginUsingOtherDeviceButton =
    !qrCodeButtonClicked &&
    !tryingToOpenApp &&
    (browserType !== "desktop" || (browserType === "desktop" && !startQrCodeOnDesktop)) &&
    bankIdStatus !== "failed" &&
    eportStatusSuccess !== false;

  const showStartAppButton =
    (!isIntializing && !qrCodeButtonClicked && !tryingToOpenApp && !bankIdStatus && bankIdStatus !== "failed") ||
    (bankIdStatus === "pending" && bankIdHintCode === "outstandingTransaction");

  const showTryAgainButton = bankIdStatus === "failed" || eportStatusSuccess === false;

  const showCancelButton =
    (tryingToOpenApp || qrCodeButtonClicked) && bankIdStatus !== "failed" && eportStatusSuccess !== false;

  const showSpinner =
    (isIntializing && bankIdStatus !== "complete" && bankIdStatus !== "failed") ||
    tryingToOpenApp ||
    (bankIdStatus === "pending" && bankIdHintCode === "userSign");

  const showMessageAndQrCard = showQrCode || !showStartAppButton;

  const showFailedMessageForMobile =
    browserType !== "desktop" && eportStatusSuccess === false && bankIdStatus !== "failed";

  return {
    showQrCode,
    showLoginUsingOtherDeviceButton,
    showStartAppButton,
    showTryAgainButton,
    showCancelButton,
    showSpinner,
    showMessageAndQrCard,
    showFailedMessageForMobile,
  };
}
